<template>
  <div>
    <el-form ref="form" label-width="80px">
      <p>
        <el-input v-model="mobile" class="login-input" placeholder="手机号">
        </el-input>
      </p>
      <p style="display: flex; justify-content: space-between">
        <el-input v-model="code" style="margin-right: 10px" class="login-input code" placeholder="请输入验证码"
          suffix-icon="el-icon-warning-outline" />
        <el-button class="getCode" type="success" @click="getCode">{{
          btn
        }}</el-button>
      </p>
      <div @click="do_login" class="login_btn_ture">登陆</div>
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: '',
  data() {
    return {
      mobile: "",
      btn: "获取验证码",
      time: 60,
      timer: null,
      code: "",
    };
  },


  methods: {
    ...mapMutations(["setInfo"]),
    // 获取验证码
    getCode() {
      if (!this.VerifyPhone()) {
        return;
      }
      if (this.time === 60) {
        this.$fecth
          .post("user/sendPhoneCode", {
            mobile: this.mobile,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: "发送成功！",
              type: "success",
            });
            this.timer = setInterval(() => {
              this.time--;
              this.btn = this.time + "s后重新发送";
              if (this.time < 1) {
                clearInterval(this.timer);
                this.timer = null;
                this.time = 60;
                this.btn = "获取验证码";
              }
            }, 1000);
          });
      }
    },
    //普通注册
    do_login() {
      if (!this.VerifyPhone()) {
        this.$message("请输入正确的手机号");
        return;
      }
      if (!this.code) {
        this.$message("请输入验证码");
        return;
      }
      this.$fecth
        .post("users/login/login_mobile_code", {
          mobile: this.mobile,
          code: this.code,
        })
        .then((res) => {
          if (res) {
            localStorage.setItem("TOKEN", res.token);
            delete res.userInfo.profile;
            localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
            this.$notify({
              showClose: true,
              message: "恭喜你，登录成功！",
              type: "success",
            });
            this.setInfo(res.userInfo);
            setTimeout(() => {
              this.$router.push("/");
            }, 1000);
          }
        });
    },
    VerifyPhone() {
      let reg = /^1[0-9]{10}$/;
      if (
        this.mobile == "" ||
        this.mobile.length <= 10 ||
        !reg.test(this.mobile)
      ) {
        this.$message("手机号格式错误");
        return;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped lang='less'>
.login-input {
  margin-bottom: 20px;
}

.login_btn_ture {
  background: #12a0f3;
  line-height: 40px;
  color: white;
  text-align: center;
  letter-spacing: 3px;
  font-size: 16px;
  border-radius: 4px;
}

.getCode {
  height: 40px;
}

.login-tip {
  position: relative;

  .title {
    text-align: center;
  }

  .msg {
    text-align: center;
    margin: 20px 0;
  }

  .btn {
    text-align: center;
  }
}
</style>
